import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPromos = lazy(() => import("@/pages/admin/AdminPromos"));

export const Route = createFileRoute("/admin/promos")({
  component: AdminPromos,
});
